import FadeIn from "react-fade-in";
import LandingBlock from "./LandingBlock";
import DescriptionBLock from "./DescriptionBLock";
import ContentBlock from "./ContentBlock";
import MoreBlock from "./MoreBlock";
import PriceBlock from "./PriceBlock";
// import TeachersBlock from "./TeachersBlock";
import FAQ from "./FAQ";
import WhyBlock from "./WhyBlock";
// import PlacesBlock from "./PlacesBlock";
import Footer from "../../Components/Footer";
import { useState } from "react";
import BookPopup from "./BookPopup";
import Header from "../../Components/Header";
// import HowLesson from "./HowLesson";
import Program from "./Program";
import Review from "./Review";
import NewTeachersBlock from "./NewTeachersBlock";

export default function MainPage() {
  const [bookPopup, setBookPopup] = useState(false);
  return (
    <div>
      <Header />
      <LandingBlock setPopup={() => setBookPopup(true)} />
      <DescriptionBLock />
      <ContentBlock />
      {/*<HowLesson />*/}
      <MoreBlock />
      <PriceBlock setPopup={() => setBookPopup(true)} />
      <Program />
      <NewTeachersBlock />
      {/*<WhyBlock />*/}
      <FAQ />

      {/*<PlacesBlock setPopup={() => setBookPopup(true)} />*/}
      <Review />
      <Footer />
      {bookPopup && (
        <BookPopup close={() => setBookPopup(false)}>book popup</BookPopup>
      )}
    </div>
  );
}
